'use strict';

/**
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Cengiz Mardin <cm@humans.am>
 */

var LayoutView = require('base/Colido.LayoutView');

var template = require('modules/settings/templates/layout/notifications.hbs');

var NotificationsLayout = LayoutView.extend({
    template: template,
});

module.exports = NotificationsLayout;